import React, { useState } from 'react'
import { Modal } from 'antd'
import EyeOutlined from '@ant-design/icons/EyeOutlined'
import { Button } from '@surecompanies/core_components'
import { InvoiceDeliveryItemDto } from '../../../api/dto/invoice-delivery.dto'
import { EmailPreviewCard } from './EmailPreviewCard'
import { TemplateEditor } from './TemplateEditor'
import { INVOICE_TEMPLATE_CUSTOMER_LABELS } from './invoiceTemplates'
import {
  EmailRow,
  EmailRowLabel,
  EmailRowValue,
  PreviewModalTitle,
  PreviewModalSubtitle,
} from './EmailPreview.styles'

interface EmailPreviewSectionProps {
  delivery: InvoiceDeliveryItemDto
  /** The month's deliveries, so OE1 can quote its paired OE2 balance. */
  monthDeliveries: InvoiceDeliveryItemDto[]
  onUpdated: (delivery: InvoiceDeliveryItemDto) => void
}

/** One drawer row: which email this invoice gets, and a button to read it. */
const EmailPreviewSection: React.FC<EmailPreviewSectionProps> = ({
  delivery,
  monthDeliveries,
  onUpdated,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <EmailRow>
        <EmailRowLabel>Email</EmailRowLabel>
        <EmailRowValue>
          <TemplateEditor
            delivery={delivery}
            monthDeliveries={monthDeliveries}
            onUpdated={onUpdated}
          />
          <Button
            size="small"
            icon={<EyeOutlined />}
            onClick={() => setIsOpen(true)}
          >
            Preview email
          </Button>
        </EmailRowValue>
      </EmailRow>

      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        width={680}
        destroyOnClose
        title={
          <PreviewModalTitle>
            Email preview
            <PreviewModalSubtitle>
              {INVOICE_TEMPLATE_CUSTOMER_LABELS[delivery.invoiceTemplate]}
            </PreviewModalSubtitle>
          </PreviewModalTitle>
        }
      >
        <EmailPreviewCard delivery={delivery} />
      </Modal>
    </>
  )
}

export { EmailPreviewSection }
